import { Routes } from '@angular/router';
import { FirstTemplate } from './pages/first-template/first-template';
import { Main } from './pages/main/main';
import { PageNotFound } from './pages/page-not-found/page-not-found';
import { PrivacyPolicy } from './pages/privacy-policy/privacy-policy';
import { ProductPage } from './pages/product-page/product-page';
import { SectorsPage } from './pages/sectors-page/sectors-page';
import { TermsOfUse } from './pages/terms-of-use/terms-of-use';

export const routes: Routes = [
    {
        path: '',
        component: Main
    },
    {
        path: 'security-policy',
        component: PrivacyPolicy
    },
    {
        path: 'cookie-policy',
        component: TermsOfUse
    },
    {
        path: 'sectors/:slug',
        component: SectorsPage
    },
    {
        path: 'sectors/public-security/:slug',
        component: FirstTemplate
    },
    {
        path: 'sectors/private-security/:slug',
        component: FirstTemplate
    },
    {
        path: 'sectors/inspections/:slug',
        component: FirstTemplate
    },
    {
        path: 'products/:slug',
        component: ProductPage
    },
    {path: '**', component: PageNotFound}, // Wildcard route for a 404 page

];
